import {
  capitalizeEachWord,
  formatDateDDMMYYYY,
} from "../utils/commonFunctions";

const COMPANY_NAMES = {
  all: "Kochar Infotech Ltd.",
  kochar: "Kochar Infotech Ltd.",
  maxicus: "Maxicus Technologies Pvt. Ltd.",
  igzy: "Igzy Technologies Pvt. Ltd.",
  kochiva: "Kochiva Pvt. Ltd.",
  kocharsoft: "Kochar Innovation Pvt. Ltd.",
};

const COMPANY_LOGOS = {
  kochar: "https://maxicus.com/mailer/kochar_hiring.png",
  maxicus: "https://maxicus.com/mailer/maxicus.png",
  igzy: "https://maxicus.com/mailer/igzy_hiring.png",
  kochiva: "https://maxicus.com/mailer/kochiva_hiring.png",
  kocharsoft: "https://maxicus.com/mailer/kocharsoft_hiring.png",
};

const getCompanyKey = (businessType = "") => {
  const value = String(businessType || "").toLowerCase();

  if (value.includes("kochiva")) return "kochiva";
  if (value.includes("kocharsoft") || value.includes("kochar innovation")) {
    return "kocharsoft";
  }
  if (value.includes("igzy")) return "igzy";
  if (value.includes("maxicus")) return "maxicus";
  if (value.includes("kochar") || value === "all") return "kochar";

  return value;
};

const useDeclarationPrefilledData = () => {
  const filledDeclarationData = (
    html,
    application,
    sign,
    aadharDetails,
    businessType,
  ) => {
    const companyKey = getCompanyKey(
      businessType || application?.trf?.businessType,
    );
    const employeeName = capitalizeEachWord(
      aadharDetails?.aadharVerificationDetails?.data?.full_name ||
        application?.name ||
        "",
    );
    const declarationDate = application?.declarationDate
      ? formatDateDDMMYYYY(new Date(application.declarationDate))
      : formatDateDDMMYYYY(new Date());

    ["name", "name_1"].forEach((fieldId) => {
      const field = html.getElementById(fieldId);
      if (field) {
        field.innerText = employeeName;
      }
    });

    ["date_of_joining", "date"].forEach((fieldId) => {
      const field = html.getElementById(fieldId);
      if (field) {
        field.innerText = declarationDate;
      }
    });

    const signature = html.getElementById("signature");
    if (signature && sign) {
      signature.src = sign;
    }

    const logo = html.getElementById("logo");
    if (logo && COMPANY_LOGOS[companyKey]) {
      logo.src = COMPANY_LOGOS[companyKey];
    }

    const companyTitle = html.getElementById("company_name");
    if (companyTitle) {
      companyTitle.innerText =
        COMPANY_NAMES[companyKey] || application?.trf?.businessType || "";
    }

    return html;
  };

  return { filledDeclarationData };
};

export default useDeclarationPrefilledData;
